module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content",
    staticStyle: {
      "background-color": "#ffffff"
    }
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "popoverName": ".popoverDashboard",
      "subNavTitle": _vm.dashboard_Dashboard,
      "menuAccess": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "dashboardWelcome"
  }, [_c('div', {
    staticClass: "dashboardWelcome-inner"
  }, [_vm._v(_vm._s(_vm.$t('dashboard.hello_label')) + " " + _vm._s(_vm.userName) + " !")])]), _vm._v(" "), _vm._l((_vm.statusCardsData), function(CardsRow) {
    return _c('status-cards-row', {
      key: CardsRow.key,
      attrs: {
        "statusCards": CardsRow.values,
        "filterSendBox": _vm.filterLastMonth
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('card-header', {
    attrs: {
      "label": _vm.barChartTitle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-content hiddenElement monthlyActivityGraph",
    style: (_vm.borderColors)
  }, [_c('canvas', {
    staticClass: "barChart"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('card-header', {
    attrs: {
      "label": 'dashboard.monthly_valid_transaction'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-content monthlyActivityGraph hiddenElement",
    style: (_vm.borderColors)
  }, [_c('div', {
    staticClass: "calendar"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "data-table card"
  }, [_c('card-header', {
    attrs: {
      "label": 'dashboard.monthly_activity'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-content hiddenElement",
    style: (_vm.borderColors)
  }, [_c('monitoring-table', {
    attrs: {
      "filterSendBox": _vm.filterLastMonth,
      "role": _vm.expectedRole
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('card-header', {
    attrs: {
      "label": 'dashboard.banks_and_cards'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-content hiddenElement logCards",
    style: (_vm.borderColors)
  }, [_c('cm-bank-accounts-list', {
    staticClass: "bankAccountDashboard",
    attrs: {
      "bankAccounts": _vm.bankAccounts,
      "SmallOnLargeScreen": true
    }
  }), _vm._v(" "), (this.bankAccounts.length === 0) ? _c('f7-list', [_c('f7-list-item', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.addBankAccount()
      }
    }
  }, [_c('f7-icon', {
    staticClass: "dashboardBankAdd",
    attrs: {
      "f7": "add_round"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('card-header', {
    attrs: {
      "label": 'dashboard.activity_card_name'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-content hiddenElement logCards",
    style: (_vm.borderColors)
  }, [_c('div', {
    staticClass: "card-content-inner"
  }, [_c('dashboard-list', {
    attrs: {
      "inMessages": _vm.inboxMessages,
      "role": _vm.expectedRole
    }
  }), _vm._v(" "), (this.inboxMessages.length === 0) ? _c('f7-list', [_c('f7-list-item', [_c('div', {
    staticClass: "finalAction"
  }, [_vm._v(_vm._s(_vm.$t('common.no_action')))])])], 1) : _vm._e()], 1)])], 1)])])], 2), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-645c5a68", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-645c5a68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/Dashboard.vue
// module id = 2380
// module chunks = 2